<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  size?: string
  info?: string | null
}

const { size = '1.25rem', info = null } = defineProps<Props>()

defineOptions({
  name: 'InfoIcon'
})

const iconProps = computed(() => ({
  size,
  icon: '$information-outline',
  class: [
    'text-secondary-600',
    { 'cursor-pointer': info, 'hover:text-primary-500': info }
  ]
}))
</script>

<template>
  <VIcon v-if="info" v-tooltip="info" v-bind="iconProps" />
  <VIcon v-else v-bind="iconProps" />
</template>
